"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Products = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _react = require("react");
var _context = require("../../context");
var _internal = require("../../hooks/internal");
var _Product = require("../Product");
var _Title = require("../Product/Title");
var _NavigationArrows = require("./NavigationArrows");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Products = ({
  initialProductCode
}) => {
  const [currentSlide, setCurrentSlide] = (0, _react.useState)(1);
  const [nextArrowVisible, setNextArrowVisible] = (0, _react.useState)(true);
  const [previousArrowVisible, setPreviousArrowVisible] = (0, _react.useState)(false);
  const sliderRef = (0, _react.useRef)();
  const {
    slider: sliderFromHook,
    navigation,
    pagination
  } = (0, _hooks.useSliderOptions)({
    initialProductCode
  });
  const {
    products
  } = (0, _internal.useProducts)();
  const {
    desktopHeight,
    mobileHeight
  } = (0, _hooks.useCarouselHeight)();
  const setArrowsVisibility = (0, _react.useCallback)(instance => {
    setCurrentSlide(instance.track.details.rel + 1);
    setNextArrowVisible(instance.track.details.rel !== instance.track.details.slidesLength - 1);
    setPreviousArrowVisible(instance.track.details.rel !== 0);
  }, []);
  // istanbul ignore next -- Check for animationEnded event not testable.
  const animationEnded = (0, _react.useCallback)(instance => {
    setArrowsVisibility(instance);
  }, [setArrowsVisibility]);
  const slider = (0, _react.useMemo)(() => ({
    ...sliderFromHook,
    created: instance => {
      sliderRef.current = instance;
      setArrowsVisibility(instance);
    },
    animationEnded
  }), [sliderFromHook, animationEnded, setArrowsVisibility]);
  if (products.length < 1) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Header, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavigationArrows.NavigationArrows, {
        currentSlide: currentSlide,
        nextArrowVisible: nextArrowVisible,
        previousArrowVisible: previousArrowVisible,
        sliderRef: sliderRef
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselComponent, {
      pagination: pagination,
      navigation: navigation,
      slider: slider,
      desktopHeight: desktopHeight,
      mobileHeight: mobileHeight,
      enableGrabCursor: products.length > 1,
      children: products.map(product => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.ProductProvider, {
          value: product,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Product.Product, {})
        })
      }, product.code))
    })]
  });
};
exports.Products = Products;